export default {
  ADMIN: 'admin',
  XEM: 'xem',
  NHAP_LIEU: 'nhapLieu',
  QUAN_LY_THON: 'quanLyThon',
  QUAN_LY_XA: 'quanLyXa',
  THONG_KE: 'thongKe',
  DANH_MUC: 'danhMuc',
  HE_THONG: 'heThong',
  QUAN_LY_CHI_TIEU: 'quanLyChiTieu'
};
